import innospaceLogo from '@/assets/innospace-logo.png';
import { VENDOR_NAME, VENDOR_WEBSITE_URL } from '@/constants/app.constants';
import { cn } from '@/lib/utils';

interface VendorCreditProps {
  layout?: 'inline' | 'stacked';
  className?: string;
}

export function VendorCredit({ layout = 'inline', className }: VendorCreditProps) {
  const isStacked = layout === 'stacked';

  return (
    <a
      href={VENDOR_WEBSITE_URL}
      target="_blank"
      rel="noreferrer noopener"
      className={cn(
        'flex items-center gap-1.5 rounded-md transition-colors hover:bg-muted',
        isStacked ? 'px-2 py-0.5' : 'justify-center',
        className,
      )}
    >
      <img
        src={innospaceLogo}
        alt=""
        className={cn('w-auto shrink-0', isStacked ? 'h-5.5' : 'h-5')}
      />
      <span
        className={cn(
          'min-w-0 text-muted-foreground',
          isStacked ? 'flex flex-col leading-tight' : 'flex items-center gap-1 text-sm',
        )}
      >
        <span className={cn('whitespace-nowrap', isStacked && 'text-3xs')}>Powered By:</span>
        <span className={cn('truncate font-medium text-brand-link', isStacked && 'text-xs')}>
          {VENDOR_NAME}
        </span>
      </span>
    </a>
  );
}
